<div class="containeer">
  <div class="row">
    <div class="col-auto g-0 d-flex align-items-start">
      <app-uiform-side-menu
        [uiformId]="uiformId"
        targetId="usecaseHelp"
        [usecaseId]="usecaseId"
        [appId]="attributeId"
      >
      </app-uiform-side-menu>
    </div>

    <div class="col-11">
      <div class="row">
        <div class="col col-md-12">
          <h5>
            <i class="fa fa-info-circle text-primary"></i> {{ usecaseSchema["name"] }} > Help
          </h5>
        </div>
        <div class="col col-md-12 mt-3">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">{{ form.data["title"] }}</h4>
              <p class="text-muted">{{ form.data["description"] }}</p>
            </div>

            <div class="card-body"> 
              <div *ngIf="form.data['id'] > 0">
                <div
                  *ngFor="let field of form.data['fields']; let i = index"
                  class="col-{{ form.data.cols }}"
                >
                  <ng-container *ngIf="getAttributeById(field.id) as e">
                    <h6>{{ e.label }}</h6>
                    <p>{{ e.description }}</p>
                  </ng-container>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
